import React, {useEffect, useRef, useState} from "react";
import CaretDown from "./CaretDown";

const ResourceFilter = (props) => {

  const {
    title,
    options,
    onSelected
  } = props;

  const [selected, setSelected] = useState();
  const [opened, setOpened] = useState(false);
  const dropdownRef = useRef();


  const handleClick = (option) => {
    const decision = selected && selected.id === option.id ? null : option;
    setSelected(decision);
    setOpened(false);
    if (onSelected) {
      onSelected(decision);
    }
  }

  const handleOpen = () => {
    setOpened(!opened);
  }

  const autoClose = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpened(false);
    }
  }


  useEffect(() => {
    window.addEventListener('click', autoClose);
    return () => {
      window.removeEventListener('click', autoClose);
    }
  }, []);

  return <div className="resourcesPage__filter" ref={dropdownRef}>
    <div className="resourcesPage__filter__label">{title}</div>
    <div
      onClick={handleOpen}
      className="resourcesPage__filter__dropdown">
      <div className="resourcesPage__filter__dropdown__header">{selected ? selected.title : 'Select from list'}</div>
      <div className={`resourcesPage__filter__dropdown__options ${opened ? 'open' : ''}`}>
        {options.map((option, index) => {
          return <div
            key={index}
            className="resourcesPage__filter__dropdown__option"
            onClick={() => {
              handleClick(option)
            }}
          >
            {option.title}
          </div>
        })}
      </div>
      <CaretDown />
    </div>
  </div>

}

export default ResourceFilter;
